import { render, staticRenderFns } from "./StockPerBuyerTable.vue?vue&type=template&id=6db43b2b&"
import script from "./StockPerBuyerTable.vue?vue&type=script&lang=js&"
export * from "./StockPerBuyerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports